import { getPrimaryLanguageSubtag } from './locale.util';

export function getCountryName(code: string, locale?: string): string {
  if (!code) {
    return '';
  }

  const upper = code.toUpperCase();
  const lang = getPrimaryLanguageSubtag(locale) || 'en';

  try {
    const displayNames = new Intl.DisplayNames([lang], {
      type: 'region',
      fallback: 'code',
    });
    return displayNames.of(upper) ?? upper;
  } catch {
    return upper;
  }
}
